AdView = require 'views/ads/ad-view'
templates = require 'views/internal/templates'

module.exports = class MemberBoardsListAdView extends AdView
  tagName: 'span'
  className: 'member-boards-list-ad'
  render: ->
    @$el.html(templates.fill('member_boards_list_ad', {
      copyHtml: @copyHtml()
    }))
    @

  copy: ->
    ""



// WEBPACK FOOTER //
// ./app/scripts/views/ads/member-boards-list-ad-view.coffee